exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-0e7e8f5a].el-button--default{color:#fff!important}", ""]);

// exports
